<div class="d-flex flex-column flex-fill my-1">
    <div class="d-flex flex-row col-12 align-items-center">
        <div class="btn-toolbar mx-0 mb-0 mt-0">
            <div>
                <button (click)="save()" class="btn btn-sm btn-primary me-2" *ngIf="hasChanges()">Save</button>
                <button (click)="cancel()" class="btn btn-sm btn-success me-4" *ngIf="hasChanges()">Cancel</button>
                <button (click)="close()" class="btn btn-sm btn-primary me-4" *ngIf="!hasChanges()">Close</button>
                <button (click)="print()" class="btn btn-sm btn-success me-4" *ngIf="!hasChanges()" [hidden]="(order.statusId !== 2 && order.statusId !== 6) || showAsDialog">
                    Print Stack Detail
                </button>
            </div>
            <div class="ms-auto d-flex align-items-center">
                <ng-container>

                    <label class="mt-2 me-2">Due Date</label>
                    <dx-date-box class="me-3" [(value)]="delivery.scheduled" width="125px"></dx-date-box>
                </ng-container>



                <button class="btn btn-sm btn-success ms-3" (click)="complete()" [disabled]="hasChanges()">Complete</button>
            </div>
        </div>
        <div class="col-4 mt-2">
            <div class="d-flex align-items-baseline gap">
                <label>Stack #</label>
                <dx-select-box [items]="stackNumbers" (onValueChanged)="stackNumberChanged($event)"></dx-select-box>
            </div>
            <div class="d-flex align-items-baseline gap">
                <label>Dealer</label>
                <dx-select-box [items]="dealers" valueExpr="id" displayExpr="displayName" (onValueChanged)="dealerValueChanged($event)"></dx-select-box>
            </div>
        </div>
        <div class="d-flex align-items-baseline ms-auto me-2 gap">
            <label>Due</label>
            <dx-date-box></dx-date-box>
            <button type="button" class="btn btn-primary">Complete</button>
        </div>
    </div>
    <div class="d-flex flex-row flex-fill">
        <div class="col-4">
            <dx-data-grid #detailDataGrid keyExpr="id" class="h-100 grid-fill" [dataSource]="orderLineDetails" (onToolbarPreparing)="onToolbarPreparing($event)">
                <dxi-column dataField="orderLine.partNumber" caption="Part #" ></dxi-column>
                <dxi-column dataField="orderLine.order.shipToCity" caption="ShipToCity" ></dxi-column>
                <dxi-column dataField="vIN" caption="VIN" ></dxi-column>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                        type="button"
                        class="btn btn-sm btn-success"
                        (click)="addToStack(detailDataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="isStackFull || detailDataGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Add to Stack
                    </button>
                </div>
            </dx-data-grid>
        </div>
        <div class="col-8">
            <dx-data-grid #stackDataGrid class="h-100 grid-fill" [dataSource]="stackSlots" [showBorders]="true" >
                <dxi-column dataField="displayOrder" caption="#" sortIndex="0" sortOrder="desc" [allowSorting]="false" width="100"></dxi-column>
                <dxi-column dataField="orderLineDetail.dealer" caption="Dealer" [allowSorting]="false"></dxi-column>
                <dxi-column dataField="orderLineDetail.partNumber" caption="Part #" [allowSorting]="false"></dxi-column>
                <dxi-column dataField="orderLineDetail.vIN" caption="VIN" [allowSorting]="false"></dxi-column>
                <dxi-column dataField="orderLineDetail.shipTo" caption="Ship To" [allowSorting]="false"></dxi-column>

                <dxo-sorting [mode]="'none'"></dxo-sorting>

                <dxo-row-dragging [allowReordering]="true" [onReorder]="onStackReorder" [showDragIcons]="true"></dxo-row-dragging>
            </dx-data-grid>
        </div>
    </div>
</div>
